export default "__VITE_ASSET__DCVqR_n3__"